/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Media_TextInputs */



/**
* | output |
* | --- |
* | "Written" |
*
* @param {Community_Media_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_media_text = /** @type {((inputs?: Community_Media_TextInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Media_TextInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écrit")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escrito")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Escrito")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scritto")
	return /** @type {LocalizedString} */ ("Written")
});